import getContext from './get-context';
import getData from './get-data';
import putContext from './put-context';

const extraReducers = {
  getContext,
  getData,
  putContext,
};

export default extraReducers;
